/**
 * tm/components/PortalRecordings.tsx — FP 포털 · WM 포털의 녹음 · 대화 글(보기만 · 2026-10-28 지도사 「WM포털, FP포털, 나에게만」)
 *  url = /api/rec/fp/<토큰>/consultations/<id> 또는 /api/rec/wm/<id>/consultations/<id> — 서버가 그 상담의 FP · 함께한 WM 인지 본다
 *  고객 통화 녹음(2026-10-28) url = /api/rec/fp/<토큰>/companies/<업체> · /api/rec/wm/<id>/companies/<업체> — 제목은 통화 시각
 */
import { useEffect, useState } from 'react';
import RecordingView from './RecordingView';
import type { Rec } from './RecordingView';
import { callWhen } from '../callRec';

type AnyRec = Rec & { kind?: string; call_at?: string | null; memo?: string };

export default function PortalRecordings({ url, accent }: { url: string; accent?: string }) {
  const [list, setList] = useState<AnyRec[] | null>(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    let alive = true;
    fetch(url).then(r => r.json() as Promise<{ success: boolean; error?: string; data?: { list: AnyRec[] } }>)
      .then(j => { if (!alive) return; if (j.success && j.data) setList(j.data.list); else setErr(j.error || '불러오지 못했어요'); })
      .catch(() => { if (alive) setErr('불러오지 못했어요'); });
    return () => { alive = false; };
  }, [url]);
  if (err) return <div style={{ padding: 16, fontSize: 15, color: '#6B7684' }}>{err}</div>;
  if (!list) return <div style={{ padding: 16, fontSize: 15, color: '#6B7684' }}>불러오는 중…</div>;
  if (!list.length) return <div style={{ padding: 16, fontSize: 15, color: '#6B7684' }}>아직 올린 녹음이 없어요</div>;
  return (
    <div style={{ display: 'grid', gap: 10 }}>
      {list.map(r => (
        <div key={r.id}>
          {r.kind === 'call' && r.memo && <div style={{ fontSize: 15, color: '#333D4B', lineHeight: 1.6, margin: '0 2px 6px', whiteSpace: 'pre-wrap', wordBreak: 'keep-all' }}>{r.memo}</div>}
          <RecordingView rec={r} size="portal" accent={accent} title={r.kind === 'call' ? `${callWhen(r.call_at || r.created_at)} 통화` : undefined} />
        </div>
      ))}
    </div>
  );
}
